import { defineMessages } from "react-intl";

export default defineMessages({
  exportFailedTitle: {
    id: "yHeZRQ",
    defaultMessage: "Product Export Failed",
  },
  exportFinishedText: {
    id: "CJEIRC",
    defaultMessage:
      "Product export has finished and was sent to your email address.",
  },
  exportFinishedTitle: {
    id: "JTcz2G",
    defaultMessage: "Exporting CSV finished",
    description: "csv file exporting has finished, header",
  },
  invoiceGenerateFinishedText: {
    id: "ryAyPr",
    defaultMessage:
      "Requested Invoice was generated. It was added to the top of the invoice list on this view. Enjoy!",
  },
  invoiceGenerateFinishedTitle: {
    id: "i+Vox0",
    defaultMessage: "Invoice Generated",
    description: "invoice generating has finished, header",
  },
  invoiceGenerationFailedTitle: {
    id: "Dhherd",
    defaultMessage: "Invoice Generation",
    description: "dialog header, title",
  },
});
